export default __webpack_public_path__ + "static/media/witch-laugh.c64aeb32.mp3";